var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98466 10.734L10.3588 13.1082C10.7163 13.4657 11.2938 13.4657 11.6513 13.1082L14.0255 10.734C14.603 10.1565 14.1905 9.1665 13.3747 9.1665H8.62633C7.81049 9.1665 7.40716 10.1565 7.98466 10.734Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFilledIcon);
export default __webpack_public_path__ + "static/media/ChevronDownFilledIcon.7016e09d917bf93de5d4ed6232be785d.svg";
export { ForwardRef as ReactComponent };